import { FC, ReactNode } from 'react';
import { handleTrimOnBlur } from 'helpers/utils';
import { Field } from 'react-final-form';
import classNames from 'classnames';

type InputType = 'text' | 'number';

interface Props {
  name: string;
  label?: ReactNode;
  maxLength?: number;
  disabled?: boolean;
  type?: InputType;
  className?: string;
  format?: (value: any) => string;
  parse?: (value: string) => any;
  component?: React.ComponentType<any>;
  placeholder?: string;
  validate?: any;
  customErrorValidation?: boolean;
  customOnBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const TextField: FC<Props> = ({
  label,
  maxLength = 100,
  name,
  disabled,
  type = 'text',
  className,
  format,
  parse,
  component: CustomComponent,
  placeholder,
  validate,
  customErrorValidation,
  customOnBlur,
  ...props
}) => {
  const getHandleBlur = (input: any) => (e: React.FocusEvent<HTMLInputElement>) => {
    customOnBlur?.(e);
    handleTrimOnBlur(e, input);
  };

  return (
    <Field
      name={name}
      allowNull
      format={format}
      parse={parse}
      validate={validate}
      {...props}
      disabled={disabled}
    >
      {({ input, meta }) => {
        return (
          <div
            className={classNames('form-group', {
              'has-danger':
                ((meta.error || meta.submitError) && meta.touched) || customErrorValidation,
            })}
          >
            <div>
              {label && <label htmlFor={name}>{label}</label>}
              {CustomComponent ? (
                <CustomComponent
                  input={input}
                  meta={meta}
                  disabled={disabled}
                  className={classNames('form-control', className)}
                  {...props}
                />
              ) : (
                <input
                  {...input}
                  type={type}
                  maxLength={maxLength}
                  disabled={disabled}
                  placeholder={placeholder}
                  onBlur={getHandleBlur(input)}
                  className={classNames('form-control', className)}
                />
              )}
              {(((meta.error || meta.submitError) && meta.touched) || customErrorValidation) && (
                <label htmlFor={name} className="error">
                  {meta.error || meta.submitError}
                </label>
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
};
